import React, { Component } from 'react'
import { useFormikContext, ErrorMessage } from 'formik'
import { connect } from 'react-redux'

import { SelectDropdown, TextInputNew, Wrapper } from 'SRC/ui/FormElementsNew'

import { NameSurname } from '../NameSurname'
import { Country } from '../Country'
import { City } from '../City'
import { Location } from '../Location'
import { Email } from '../Email'
import { Phone } from '../Phone'

export const Container = ({
  isActive
}) => {
  const formik = useFormikContext()

  if (!formik.values.newUser) return null

  return (
    <div className={`kontakt-podaci-content ${isActive ? `active` : ``}`}>
      <div>
        <NameSurname />
        <Country />
        <City />
        <Location />
        <Phone />
        <Email />
      </div>
    </div>
  )
}
